import { defineMessages } from 'react-intl';

export const vocabTrackMsgs = defineMessages({
  chooseTitle: {
    id: 'vocab_tracks_choose_title',
    defaultMessage: 'Choose the vocab',
  },
  chooseSubheader: {
    id: 'vocab_tracks_choose_subheader',
    defaultMessage: "Choose the words that we'll build your Memrise course around.",
  },
  chooseTitleEuropeanSpanish: {
    id: 'vocab_tracks_choose_title_es',
    defaultMessage: 'Choose your course vocab',
  },
  chooseSubheaderEuropeanSpanish: {
    id: 'vocab_tracks_choose_subheader_es',
    defaultMessage:
      'You’ll build the same skills whatever vocab you learn, so pick what’s relevant to you',
  },
  changeLaterNote: {
    id: 'vocab_tracks_change_later_note',
    defaultMessage: 'You can always change this later',
  },
  startAnywhereNote: {
    id: 'vocab_tracks_start_anywhere_note',
    defaultMessage: 'Start with any theme or word list — you can always change this later',
  },
  schoolExams: {
    id: 'vocab_tracks_school_exams',
    defaultMessage: 'School & exams',
  },
  startHere: {
    id: 'vocab_tracks_start_here',
    defaultMessage: 'Start here',
  },
  previous: {
    id: 'onboarding_nav_previous',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'vocab_tracks_next',
    defaultMessage: 'Next',
  },
  changeTitle: {
    id: 'vocab_tracks_change_title',
    defaultMessage: 'Change Vocab track',
  },
  changeSubheader: {
    id: 'vocab_tracks_change_subheader',
    defaultMessage:
      "Choose the words that we'll build your Memrise course around. When you change vocab track we'll automatically update your course path.",
  },
  currentBadge: {
    id: 'wordlists_currentlylearning_label',
    defaultMessage: 'Currently learning',
  },
  completedBadge: {
    id: 'wordlist_completedscreen_label',
  },
  wordCount: {
    id: 'wordlists_viewlist_section1_subheader',
  },
  changeVocabList: {
    id: 'vocab_tracks_change_list',
    defaultMessage: 'Change Vocab list',
  },
  themeCount: {
    id: 'vocab_tracks_theme_count',
    defaultMessage: '{themeCount} themes',
  },
  viewDetails: {
    id: 'vocab_tracks_view_details',
    defaultMessage: 'View details',
  },
  communityCardTitle: {
    id: 'vocab_tracks_community_card_title',
    defaultMessage: 'Community Word lists',
  },
  communityCardDescription: {
    id: 'vocab_tracks_community_card_description',
    defaultMessage: 'Browse lists made by other learners, or create your own.',
  },
  contentsTitle: {
    id: 'vocab_tracks_contents_title',
    defaultMessage: '{trackTitle} contents',
  },
  contentsSubheader: {
    id: 'vocab_tracks_contents_subheader',
    defaultMessage:
      'Learn the full list from the start, or jump straight to any theme or topic — nothing is locked.',
  },
  learnWholeList: {
    id: 'vocab_tracks_learn_whole_list',
    defaultMessage: 'Learn the whole list from the start',
  },
  vocabByTheme: {
    id: 'vocab_tracks_vocab_by_theme',
    defaultMessage: 'Vocab by Theme',
  },
  pickTopic: {
    id: 'vocab_tracks_pick_topic',
    defaultMessage:
      'Or pick a specific topic now. You can always change your vocab list at any time',
  },
  learnTopic: {
    id: 'vocab_tracks_learn_topic',
    defaultMessage: 'Learn {topicTitle}',
  },
  selectTrack: {
    id: 'vocab_tracks_select_track',
    defaultMessage: 'Select {trackTitle}',
  },
  selectThisWordlist: {
    id: 'vocab_tracks_select_this_wordlist',
    defaultMessage: 'Select this word list',
  },
  communitySearchPlaceholder: {
    id: 'cwl_dashboard_search_bar_placeholder',
    defaultMessage: 'Search by word list title or description',
  },
  communityNoResults: {
    id: 'content_discovery_no_results',
    defaultMessage: 'No results',
  },
  communityClearSearch: {
    id: 'content_discovery_clear',
    defaultMessage: 'Clear',
  },
  communityByAuthor: {
    id: 'vocab_tracks_community_by_author',
    defaultMessage: 'by {author}',
  },
  continueLearning: {
    id: 'vocab_tracks_continue_learning',
    defaultMessage: 'Continue learning',
  },
  backToVocab: {
    id: 'vocab_tracks_back_to_vocab',
    defaultMessage: 'Back to Vocab',
  },
});
